import { i18n } from "@/services/vue-i18n";

var isUrl = str => {
  // https://stackoverflow.com/a/5717133/3080250
  var pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
    "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
    "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
    "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
    "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator
  return !!pattern.test(str);
};

export default {
  required: [v => !!v || i18n.t("validation.general.required")],
  text: {
    min: [v => !v || v.length >= 2 || i18n.t("validation.general.text.min")],
    small: [
      v => !v || v.length <= 255 || i18n.t("validation.general.text.small")
    ],
    default: [
      v => !v || v.length <= 65535 || i18n.t("validation.general.text.regular")
    ]
  },
  specials: {
    none: [
      v =>
        !/[!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?]/.test(v) ||
        i18n.t("validation.general.specials.none")
    ]
  },
  numbers: {
    isOne: [
      v => !v || /\d/.test(v) || i18n.t("validation.general.numbers.is-one")
    ],
    none: [v => !/\d/.test(v) || i18n.t("validation.general.numbers.none")],
    strictPositive: [
      v => !v || /\d/.test(v) || i18n.t("validation.general.numbers.is-one"),
      v => !v || v > 0 || i18n.t("validation.general.numbers.strict-positive")
    ]
  },
  arrays: {
    notEmpty: [
      v => !v || v.length !== 0 || i18n.t("validation.general.arrays.not-empty")
    ]
  },
  url: [v => !v || isUrl(v) || i18n.t("validation.general.url")],
  image: [
    v => !v || isUrl(v) || i18n.t("validation.general.url"),
    v =>
      !v ||
      v.match(/\.(jpeg|jpg|gif|png)$/) !== null ||
      i18n.t("validation.general.image")
  ]
};
